var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button-gradient",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('div',{staticClass:"button-inner"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }